import { FunctionComponent } from 'react'
import { useWidgetContext, WidgetDisplayMode } from '@dxp-module/common'
import MiniWidgetButton from '../widgetButtonWrapper/MiniWidgetButtonWrapper'
import MiniWidgetTabs from '../widgetTabs/MiniWidgetTabs'

const MiniWidgetContent: FunctionComponent = () => {
  const {
    configuration: { displayMode },
  } = useWidgetContext()

  if (displayMode === WidgetDisplayMode.AUTH_SCREEN) {
    return <MiniWidgetTabs />
  }

  return <MiniWidgetButton />
}

export default MiniWidgetContent
